import { marginTop, fontSize, fontWeight, pxToRem, themeGet } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const mobileNavItemHeight = '4.375rem';
export const Container = styled.div `
  display: flex;
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  background: ${themeGet('colors.gray.0')};
  box-shadow:
    0 0 ${pxToRem(0.1)} rgb(0 0 0 / 2%),
    0 0 ${pxToRem(0.3)} rgb(0 0 0 / 2.8%),
    0 0 ${pxToRem(0.6)} rgb(0 0 0 / 3.5%),
    0 0 ${pxToRem(1.1)} rgb(0 0 0 / 4.2%),
    0 0 ${pxToRem(2.1)} rgb(0 0 0 / 5%),
    0 0 ${pxToRem(5)} rgb(0 0 0 / 7%);
`;
export const Navigation = styled.nav `
  display: flex;
  width: 100%;
  align-items: stretch;
  justify-content: stretch;
`;
export const NavItemText = styled.span `
  ${marginTop(2)};
  ${fontSize('tiny', 1)};
`;
export const NavItemContainer = styled.button `
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  align-items: center;
  justify-content: center;
  height: ${mobileNavItemHeight};
  border: none;
  background-color: transparent;
  text-decoration: none;

  svg {
    color: ${({ $active }) => ($active ? themeGet('colors.primary.500') : themeGet('colors.gray.400'))};
  }

  ${({ $active }) => fontWeight($active ? 'bold' : 'normal')};

  ${NavItemText} {
    color: ${({ $active }) => ($active ? themeGet('colors.gray.700') : themeGet('colors.gray.400'))};
  }
`;
